import React from 'react';
import './PageLoading.css';

const PageLoading = ({ label = 'Loading page…' }) => (
  <div className="page-loading" role="status" aria-live="polite">
    <span className="page-loading__spinner" aria-hidden="true" />
    <span>{label}</span>
  </div>
);

export default PageLoading;
